import React, { useEffect } from 'react';
import { Box, Button, Typography, CircularProgress, Alert } from '@mui/material';
import { useAuth } from './AuthProvider';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const Login: React.FC = () => {
  const { login, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isAuthenticated) {
      // Redirect to the return URL if provided, otherwise go to dashboard
      const returnUrl = searchParams.get('returnUrl');
      navigate(returnUrl || '/');
    }
  }, [isAuthenticated, navigate, searchParams]);

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: 3,
        backgroundColor: '#f5f7fa'
      }}>
        <CircularProgress />
        <Typography>Checking authentication...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: 3,
      backgroundColor: '#f5f7fa'
    }}>
      <Box component="img" 
           src="/magna-logo-official-dark.svg" 
           alt="Magna Legal Services" 
           sx={{ height: 60, mb: 2 }} />
      <Typography variant="h1" sx={{ mb: 2 }}>
        Reporter Portal Admin
      </Typography>
      
      <Alert severity="info" sx={{ mb: 2, maxWidth: 400 }}>
        Sign in with your organizational account to access the admin portal.
      </Alert>
      
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleLogin}
        size="large"
        disabled={isLoading}
      >
        Sign in with Microsoft
      </Button>
    </Box>
  );
};